__turbopack_context__.v({
  "after": "PortalDivider-module__05K6dW__after",
  "band": "PortalDivider-module__05K6dW__band",
  "before": "PortalDivider-module__05K6dW__before",
});
